// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralForegroundHint, neutralForegroundRest, neutralLayerCard } from "@microsoft/fast-components-styles-msft";
import { placeholderColor, reset } from "../../utils/commonJssConstants";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";

const inputFontSize = "14px";

export const UGContentCreateView1Styles = (config: DesignSystem) => ({
    ugContentCreateView1Container: {
        ...reset,

        "& .cwt-content-generation-form": {
            display: "flex",
            "flex-direction": "column",
            "align-items": "center",
            height: "100vh"
        },

        "& .cwt-media-input": {
            width: "100%"
        },

        "& .cwt-text-input-group": {
            display: "flex",
            "flex-direction": "column",
            width: "800px",
            "max-width": "100%"
        },

        "& .cwt-input": {
            padding: "2px 8px",
            "font-size": inputFontSize,
            background: neutralLayerCard,
            color: neutralForegroundRest,
            border: "none",

            "&::placeholder": {
                "font-weight": "normal",
                color: placeholderColor,
                opacity: "1"
            },

            "&:focus": {
                outline: "none !important",
                [applyLocalizedProperty("border-left", "border-right", config.direction)]: "2px solid ",
                "border-color": neutralForegroundHint,
                [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "-2px"
            }
        },

        "& .cwt-rich-text-input": {

            "&[contenteditable]": {
                "&:empty:before": {
                    content: "attr(placeholder)",
                    "pointer-events": "none",
                    display: "block",
                    color: placeholderColor,
                    "font-weight": "normal",
                    "font-size": "inherit"
                }
            }
        },

        "& .cwt-title, & .cwt-title *": {
            "margin-top": "32px",
            "font-size": "42px",
            "line-height": "48px",
            "font-weight": "600",
            "letter-spacing": applyLocalizedProperty(".02em", "0", config.direction)
        },

        "& .cwt-body": {
            "margin-top": "24px",
            "min-height": "3em",
            "font-size": "20px",
            "line-height": "32px"
        }
    }
});